import { BrowserRouter, Switch, } from 'react-router-dom';
import AppLayout from './components/AppLayout';
import Home from './components/Home';
import Home2 from './components/Home2';
import Home3 from './components/Home3';
import Home4 from './components/Home4';
import Home5 from './components/Home5';
import Home6 from './components/Home6';
import Home7 from './components/Home7';
import Home8 from './components/Home8';
import Home9 from './components/Home9';
import Home9W from './components/Home9W';
import Home9W2 from './components/Home9W2';
import Home10 from './components/Home10';
// import Home11 from './components/Home11';
import Home12 from './components/Home12';
import Home12Services from './components/Home12Services';
import Home12Construction from './components/Home12Construction';
import Home12Download from './components/Home12Download';
import Home12Contact from './components/Home12Contact';
import Home12Company from './components/Home12Company';
import Home12ThankYou from './components/Home12ThankYou';
import ScrollToTop from './components/lib/ScrollToTop';
import FirebaseAnalytics from './components/lib/FirebaseAnalytics';
import NotFound from './components/NotFound';
import Privacy from './components/Privacy';
import DefaultLayout from './components/DefaultLayout';


function App() {
    return (
        <BrowserRouter>
            <FirebaseAnalytics />
            <ScrollToTop />

            <Switch>
                <AppLayout exact path="/home" component={Home} />
                <DefaultLayout exact path="/home2" component={Home2} />
                <DefaultLayout exact path="/home3" component={Home3} />
                <DefaultLayout exact path="/home4" component={Home4} />
                <DefaultLayout exact path="/home5" component={Home5} />
                <DefaultLayout exact path="/home6" component={Home6} />
                <DefaultLayout exact path="/home7" component={Home7} />
                <DefaultLayout exact path="/home8" component={Home8} />
                <DefaultLayout exact path="/home9" component={Home9} />
                <DefaultLayout exact path="/home9-w" component={Home9W} />
                <DefaultLayout exact path="/home9-w2" component={Home9W2} />
                <DefaultLayout exact path="/home10" component={Home10} />
                {/* <DefaultLayout exact path="/home11" component={Home11} /> */}
                <DefaultLayout exact path="/" component={Home12} />
                <DefaultLayout exact path="/services" component={Home12Services} />
                <DefaultLayout exact path="/construction" component={Home12Construction} />
                <DefaultLayout exact path="/download" component={Home12Download} />
                <DefaultLayout exact path="/contact" component={Home12Contact} />
                <DefaultLayout exact path="/thank-you" component={Home12ThankYou} />
                <DefaultLayout exact path="/company" component={Home12Company} />
                <AppLayout exact path="/privacy" component={Privacy} />

                <AppLayout component={NotFound} status={404} />
            </Switch>
        </BrowserRouter>
    );
}

export default App;
